import env from '@/config/env'
import request from '@/router/axios'

/**
 * 会员管理
 */

// 获取字典值
export const getMemberDic = () => {
  return request({
    url: `${env.ferryUrl}/crm/dic`,
    method: 'GET'
  })
}

// 获取会员等级
export const getMemberLevel = (data) => {
  return request({
    url: `${env.ferryUrl}/member/level?days=${data}`,
    method: 'GET'
  })
}

// 获取会员方案
export const getMemberPlan = () => {
  return request({
    url: `${env.ferryUrl}/member/plan`,
    method: 'GET'
  })
}

// 保存会员方案
export const saveMemberPlan = (data) => {
  return request({
    url: `${env.ferryUrl}/member/plan/save`,
    method: 'POST',
    data
  })
}

// 获取会员活动
export const getMemberActivity = () => {
  return request({
    url: `${env.ferryUrl}/member/activity`,
    method: 'GET'
  })
}

// 获取会员活动详情
export const getMemberActivityDetail = (data) => {
  return request({
    url: `${env.ferryUrl}/member/activity/detail?type=${data}`,
    method: 'GET'
  })
}

// 保存会员活动
export const getMemberActivitySave = (data) => {
  return request({
    url: `${env.ferryUrl}/member/activity/save`,
    method: 'POST',
    data
  })
}

// 会员管理统计
export const getMemeberCount = (data) => {
  return request({
    url: `${env.ferryUrl}/member/count?days=${data}`,
    method: 'GET'
  })
}

/**
 * 会员积分
 */

// 获取会员积分规则
export const getMemberScoreRule = (data) => {
  return request({
    url: `${env.ferryUrl}/member/score/rule`,
    method: 'GET'
  })
}

// 保存会员积分规则
export const saveMemberScoreRule = (data) => {
  return request({
    url: `${env.ferryUrl}/member/score/rule/save`,
    method: 'POST',
    data
  })
}

// 会员积分统计
export const getMemberScoreCount = (data) => {
  return request({
    url: `${env.ferryUrl}/member/score/count`,
    method: 'GET'
  })
}
